import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../../components/Toast/showToast';
import { i18translation } from '../../../locale/translations/i18NsPaths';

const useSamlRedirectNotification = () => {
  const { t } = useTranslation();
  const samlRedirectAndNotification = window.sessionStorage.getItem('samlRedirectAndNotification');

  useEffect(() => {
    if (samlRedirectAndNotification) {
      window.sessionStorage.removeItem('samlRedirectAndNotification');
      window.sessionStorage.setItem('redirectToSamlConfig', 'true');

      const notificationsKey = i18translation.accessManagement.tabs.singleSignOn.notifications;

      switch (samlRedirectAndNotification) {
        case 'success':
          showToast(
            {
              message: t(notificationsKey.testSuccessTitle),
              description: t(notificationsKey.testConnectionReturnToConfig)
            },
            'success'
          );
          break;
        case 'failed':
          showToast({
            message: t(notificationsKey.testFailedTitle),
            description: t(notificationsKey.testConnectionReturnToConfig)
          });
          break;
        case 'success_activation':
          showToast(
            {
              message: t(notificationsKey.successTitle),
              description: t(notificationsKey.testConnectionSuccess)
            },
            'success'
          );
          break;
        case 'failed_activation':
          showToast({
            message: t(notificationsKey.failedTitle),
            description: t(notificationsKey.testConnectionFailed)
          });
          break;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [samlRedirectAndNotification]);
};

export default useSamlRedirectNotification;
